/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */

export type EvalRunSummaryStatus =
  (typeof EvalRunSummaryStatus)[keyof typeof EvalRunSummaryStatus];

export const EvalRunSummaryStatus = {
  completed: "completed",
  failed: "failed",
} as const;
